import React, { Component } from 'react';
import Moment from 'react-moment';
import { Link } from 'react-router-dom';
import MessageDetailItem from './MessageDetailItem';

export default class MessageDetailList extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { messageDetails, user, targetUser, currentUserId, onReply, onReact, onRecall } = this.props;

        return (
            <>
                {
                    /* Key phải bám theo tin, không dùng index: khi chèn tin cũ vào đầu
                       mảng toàn bộ index dịch đi, React sẽ tái sử dụng nhầm component
                       (ảnh đã tải và state showTime gắn sang tin khác). */
                    messageDetails.map((messageDetail, index) => (
                        <MessageDetailItem
                            key={messageDetail.key || messageDetail.firebaseId || index}
                            messageDetail={messageDetail}
                            user={user}
                            currentUserId={currentUserId || (user && user.facebookId)}
                            targetUser={targetUser}
                            onReply={onReply}
                            onReact={onReact}
                            onRecall={onRecall}
                        />
                    ))
                }
            </>
        );
    }
}
